import React, { ReactElement, useContext } from 'react';
import { Layout } from 'antd';
import styles from './AppContent.module.less';
import AppRoute from '../../AppRoute';
import { Alert } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { UserContext } from '../../core/context/UserContext';
import { notification } from 'antd';
import CcxIconCloseCircleTwoTone from '../ccx/icons/CcxIconCloseCircleTwoTone';
import ProfileService from '../../services/ProfileService';
import AppContentTemplate from './AppContentTemplate';

const { Content } = Layout;

interface UrlProps {
    projectUuid: string;
}

function AppContent(): ReactElement {
    let { projectUuid } = useParams<UrlProps>();

    const { user: userContext, setUser } = useContext(UserContext);

    const onAlertClose = async () => {
        try {
            const ret = await ProfileService.updateProfile('false');
            setUser && setUser(ret);
        } catch (e) {
            notification.open({
                message: 'New User',
                description: `There was an error . ${e}`,
                icon: <CcxIconCloseCircleTwoTone twoToneColor="#eb2f96" />,
            });
        }
    };

    return (
        <AppContentTemplate>
            {userContext?.isNewUser() && (
                <Alert
                    message={
                        <>
                            You have successfully completed your account. Enjoy
                            CCX by{' '}
                            <Link
                                to={`/projects/${projectUuid}/data-stores/add`}
                            >
                                <strong>creating your first data store.</strong>
                            </Link>
                        </>
                    }
                    type="success"
                    className={styles.AppContentContainerAlert}
                    showIcon
                    onClose={onAlertClose}
                    closable
                />
            )}
            <AppRoute />
        </AppContentTemplate>
    );
}

export default AppContent;
